<template>
  <div class="stripe-2">
    <b-container>
      <b-row>
        <b-col class="text-center">
          Afíliese ahora
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Stripe2"
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.stripe-2 {
  background-color: $gray;
  color: $red;
  font-size: 2.8rem;
  text-transform: uppercase;
  font-weight: $font-weight-bold;

  @media (max-width: prev-viewport-max-size("sm")) {
    font-size: 2rem;
  }

  @media (max-width: prev-viewport-max-size("xs")) {
    font-size: 1rem;
  }
}
</style>
